var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    [
      _c("div", { staticClass: "num" }, [
        _c("i", {
          staticClass: "lnr lnr-apartment",
          staticStyle: { color: "#59ABE3" },
        }),
        _vm._v(" " + _vm._s(_vm.index + 1) + "\n    "),
      ]),
      _vm._v(" "),
      _c("h4", [
        _c("a", _vm._b({ attrs: { target: "_blank" } }, "a", _vm.href, false), [
          _vm._v(_vm._s(_vm.elementInfo.name_short)),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "span",
          { style: { color: _vm.status_type[0] == 1 ? "#87D37C" : "#cc0000" } },
          [
            _c("i", { staticClass: "lnr lnr-cross-circle" }),
            _vm._v(" "),
            _c("span", [_vm._v(" " + _vm._s(_vm.rec_status_type_text) + ",")]),
          ]
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            " зарегистрировано " +
              _vm._s(_vm.date_start) +
              _vm._s(_vm.date_stop ? ", ликвидировано " + _vm.date_stop : "")
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.name_full
        ? _c("p", [_vm._v("Полное наименование: " + _vm._s(_vm.name_full))])
        : _vm._e(),
      _vm._v(" "),
      _vm.okved_bool
        ? _c("p", [
            _vm._v(_vm._s(_vm.okved.code) + " " + _vm._s(_vm.okved.descr)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _vm.ogrn
          ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
              _vm._v("ОГРН " + _vm._s(_vm.ogrn) + ", "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.inn
          ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
              _vm._v("ИНН " + _vm._s(_vm.inn) + ", "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.okpo
          ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
              _vm._v("ОКПО " + _vm._s(_vm.okpo) + ", "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.kpp
          ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
              _vm._v("КПП " + _vm._s(_vm.kpp)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.rukovod
        ? _c("p", [
            _vm.rukovod.position
              ? _c("span", [_vm._v(_vm._s(_vm.rukovod.position) + " ")])
              : _vm._e(),
            _vm._v(" "),
            _vm.rukovod.name
              ? _c("span", { staticStyle: { "font-weight": "700" } }, [
                  _vm._v(_vm._s(_vm.rukovod.name)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.rukovod.inn
              ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
                  _vm._v(" ИНН " + _vm._s(_vm.rukovod.inn)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.address ? _c("p", [_vm._v(_vm._s(_vm.address))]) : _vm._e(),
      _vm._v(" "),
      _vm.phones
        ? _c(
            "p",
            _vm._l(_vm.phones, function (e, i) {
              return _c("span", { key: i }, [
                _c("span", [_vm._v(_vm._s(e))]),
                _vm._v(", "),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emails ? _c("p", [_vm._v(_vm._s(_vm.emails))]) : _vm._e(),
      _vm._v(" "),
      _vm.sites
        ? _c(
            "p",
            _vm._l(_vm.sites, function (e, i) {
              return _c(
                "a",
                {
                  key: i,
                  staticClass: "site-href",
                  staticStyle: { "margin-right": "10px" },
                  attrs: { target: "_blank", href: "//" + e },
                },
                [_vm._v(_vm._s(e))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("monitoring-set-delete-button", { attrs: { ogrn: _vm.ogrn } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }